import React, { Component } from 'react';
import styles from '../styles/loyalty.css';
import OtpForm from './OtpForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons'
import { Template2RenderField } from './SignUpPageTemp2.jsx';
import OtpForm2 from './OtpForm2';

export default class RegFormPageTemp2 extends Component {


    render() {
        const { themeColors, programList, source } = this.props;

        return (
            <div className={`${styles['fr-signup-root-form']} signup-root-form`}>
                {this.props.verifyMobile ?
                    <OtpForm2 themeColors={themeColors}
                        preFillData={this.props.preFillData}
                        status={this.props.status} defaultCountry={this.props.defaultCountry} isMultiCountryEnable={this.props.isMultiCountryEnable} getLoginOtp={(val) => this.props.getLoginOtp(val)} isOtpSent={this.props.isOtpSent} verifyOtp={this.props.verifyOtp} />
                    :
                    programList && programList.length &&
                    <SignUpForm
                        signUpConfiguration={this.props.signUpConfiguration}
                        readOnly={this.props.readOnly}
                        LoyaltySignUp={this.props.LoyaltySignUp}
                        getEnrollmentCriteria={this.props.getEnrollmentCriteria}
                        programList={this.props.programList}
                        attributes={this.props.attributes}
                        loading={this.props.loading}
                        loyaltyKnowMore={this.props.loyaltyKnowMore}
                        configuration={this.props.configuration}
                        themeColors={this.props.themeColors}
                        offerText={this.props.offerText}
                        preFillData={this.props.preFillData}
                        getPrograms={this.props.getPrograms}
                        status={this.props.status}
                        termsUrl={this.props.termsUrl}
                        pushPath={this.props.pushPath}
                        source={source}
                    />
                }
            </div>
        )
    }
}


class SignUpForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            termsCheck: false,
            signUpData: {
                source: props.source
            }
        }
    }

    componentDidMount() {

        this.props.programList && this.props.programList.length > 0 && this.props.getEnrollmentCriteria(this.props.programList[0].id);

        this.props.preFillData && this.props.preFillData.forEach(i => {
            this.setState({ signUpData: { ...this.state.signUpData, [i.slug]: i.value } });
        });
    }

    render() {
        const { attributes, LoyaltySignUp, preFillData, readOnly, termsUrl, themeColors } = this.props;
        const onChange = (value, slug) => {
            const key = slug;
            this.setState({ signUpData: { ...this.state.signUpData, [key]: value } });
        }
        const config = this.props.signUpConfiguration
        const themeColor = this.props.themeColors

        return (

            <div className={styles["temp2-signup-container"]} >
                <div className={styles["temp2-signup-head"]} style={{
                    backgroundImage: `url(${config.background})`, backgroundColor: themeColor?.themeColor
                }} >
                    <img src={config.image} alt="Img" style={{ width: 100, height: 100, objectFit: 'contain', borderRadius: 6 }} />
                    <div className={styles["temp2-signup-title"]} style={{ color: themeColor?.headingColor }} dangerouslySetInnerHTML={{ __html: config && config.title }}></div>
                    <span style={{ width: "85%", }} dangerouslySetInnerHTML={{ __html: config && config.subTitle }}></span>
                </div>

                {attributes && attributes.map((item, index) => {
                    let current = preFillData && preFillData.find((i) => {
                        return item.slug == i.slug;
                    });

                    let onlyRead = current && current.value && readOnly && readOnly[current && current.slug] ? true : false;
                    return <Template2RenderField item={item} value={this.state.signUpData[current && current.slug]} key={index} readOnly={onlyRead}
                        onChange={(val, key) => {
                            onChange(val, key)
                        }} />
                })}

                <div className={styles["temp2-signup-checkbox-container"]} style={{ marginLeft: 7 }} >
                    <input type="checkbox" checked={this.state.termsCheck} onClick={() => {
                        this.setState({ termsCheck: !this.state.termsCheck })
                    }} className="terms-check-box" style={{ width: "auto" }} />
                    <div style={{ display: "flex", width: "85%", height: 18 }}>
                        <span style={{ fontSize: 14, marginLeft: 7, flexDirection: "row", marginRight: 4, color: "#7a8096", fontSize: 12, alignSelf: "center" }}>
                            By agree with our  <br />
                        </span>
                        <a href={termsUrl} style={{ color: themeColor?.themeColor, fontWeight: "bold", fontSize: 12, alignSelf: "center" }} target='_blank'>Terms & Conditions</a>
                    </div>
                </div>


                <div
                    className={styles["temp2-custom-btn"]}
                >
                    <button onClick={() => {
                        if (this.state.termsCheck) {
                            LoyaltySignUp(this.state.signUpData)
                        }
                        else {
                            alert("please accept the terms & conditions");
                        }
                    }}
                        className={styles["temp1-custom-btn-field1"]}
                        style={{ backgroundColor: themeColors && themeColors.buttonBgColor, color: themeColors && themeColors.buttonTextColor }}
                    >
                        Sign Up Now<FontAwesomeIcon style={{ marginLeft: 5 }} icon={faArrowCircleRight} />
                    </button>
                </div>
                <div>
                    <button className={styles["sign-btn"]} style={{ color: themeColor?.themeColor }}>Sign Now and get 100pt</button>
                </div>
            </div>

        )
    }
}


